import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'src/App';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import reportWebVitals from 'src/reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import * as serviceWorkerRegistration from 'src/serviceWorkerRegistration';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  palette: {
    background: {
      default: '#F8F9FA'
    },
    black: {
      main: '#3a3834',
      contrastText: '#f2f2f2'
    },
    primary: {
      main: '#5280EB',
      contrastText: '#f2f2f2'
    },
    lightSuccess: {
      main: '#5280EB',
      contrastText: '#f2f2f2'
    },
    success: {
      main: '#5280EB',
      contrastText: '#f2f2f2'
    },
    strongSuccess: {
      main: '#1B2A4D',
      contrastText: '#f2f2f2'
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <App />
    </LocalizationProvider>
  </ThemeProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
